import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Typography,
  Box,
  Rating,
  Chip,
  Button,
  Avatar,
  IconButton,
  Tooltip,
  Badge,
  Divider,
  Stack,
  Grid,
  alpha,
  styled,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Star,
  LocationOn,
  AccessTime,
  Language,
  Psychology,
  Verified,
  Favorite,
  FavoriteBorder,
  Share,
  Bookmark,
  BookmarkBorder,
  Schedule,
  Phone,
  VideoCall,
  Person,
  MoreVert,
  Directions,
  Info,
  CheckCircle,
  Warning,
  Error,
  LocalHospital,
  School,
  Work,
  Payment,
  Security,
  Support,
  TrendingUp,
  People,
  EmojiEvents,
  ThumbUp,
  ThumbDown,
  Report,
  Flag,
  Block,
  NavigateNext,
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  FirstPage,
  LastPage,
  Refresh,
  Sort,
  ViewList,
  ViewModule,
  GridView,
  List as ListIcon,
  Map,
  MyLocation,
  GpsFixed,
  GpsOff,
  Notifications,
  NotificationsOff,
  Cancel,
  Add,
  Remove,
  Clear,
  Done,
  Edit,
  Delete,
  Save,
  Download,
  Upload,
  Print,
  Send,
  Reply,
  Forward,
  Archive,
  Unarchive,
  MarkEmailRead,
  MarkEmailUnread,
  Drafts,
  Inbox,
  Outbox,
  Sent,
  Trash,
  Spam,
  Label,
  Folder,
  FolderOpen,
  FolderSpecial,
  Cloud,
  CloudUpload,
  CloudDownload,
  CloudSync,
  CloudOff,
  Wifi,
  WifiOff,
  SignalCellular4Bar,
  SignalCellularConnectedNoInternet4Bar,
  SignalCellularNoSim,
  SignalCellularNull,
  SignalCellularOff,
  SignalWifi4Bar,
  SignalWifiConnectedNoInternet4Bar,
  SignalWifiOff,
  SignalWifiStatusbar4Bar,
  SignalWifiStatusbarConnectedNoInternet4Bar,
  SignalWifiStatusbarNull,
  Battery20,
  Battery30,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatteryFull,
  BatteryChargingFull,
  BatteryStd,
  BatteryUnknown,
  Brightness4,
  Brightness5,
  Brightness6,
  Brightness7,
  BrightnessAuto,
  BrightnessHigh,
  BrightnessLow,
  BrightnessMedium,
  ScreenRotation,
  ScreenShare,
  StopScreenShare,
  Cast,
  CastConnected,
  CastForEducation,
  Computer,
  DesktopMac,
  DesktopWindows,
  DeveloperBoard,
  DeviceHub,
  Devices,
  Dock,
  Gamepad,
  Headset,
  HeadsetMic,
  Keyboard,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  KeyboardArrowRight as KeyboardArrowRightIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  KeyboardBackspace,
  KeyboardCapslock,
  KeyboardHide,
  KeyboardReturn,
  KeyboardTab,
  KeyboardVoice,
  Laptop,
  LaptopChromebook,
  LaptopMac,
  LaptopWindows,
  Memory,
  Mouse,
  PhoneAndroid,
  PhoneIphone,
  Phonelink,
  PhonelinkOff,
  Router,
  Scanner,
  Security as SecurityIcon,
  SimCard,
  Smartphone,
  Speaker,
  SpeakerGroup,
  Tablet,
  TabletAndroid,
  TabletMac,
  Toys,
  Tv,
  VideogameAsset,
  Watch,
  AccessTimeFilled,
  Accessible,
  AccessibleForward,
  AccountBalance,
  AccountBalanceWallet,
  AccountBox,
  AccountCircle,
  AddShoppingCart,
  Alarm,
  AlarmAdd,
  AlarmOff,
  AlarmOn,
  AllInbox,
  AllOut,
  Android,
  Announcement,
  AspectRatio,
  Assessment,
  Assignment,
  AssignmentInd,
  AssignmentLate,
  AssignmentReturn,
  AssignmentReturned,
  AssignmentTurnedIn,
  Autorenew,
  Backup,
  Book,
  BookOnline,
  Bookmark as BookmarkIcon,
  BookmarkBorder as BookmarkBorderIcon,
  BugReport,
  Build,
  Cached,
  CalendarToday,
  CameraEnhance,
  CardGiftcard,
  CardMembership,
  CardTravel,
  ChangeHistory,
  CheckCircle as CheckCircleIcon,
  ChromeReaderMode,
  Class,
  Code,
  Commute,
  CompareArrows,
  ContactSupport,
  Copyright,
  CreditCard,
  Dashboard,
  Delete as DeleteIcon,
  Description,
  Dns,
  DoneAll,
  DonutLarge,
  DonutSmall,
  DragIndicator,
  Eco,
  EuroSymbol,
  Event,
  EventSeat,
  ExitToApp,
  Explore,
  Extension,
  Face,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  Feedback,
  FindInPage,
  FindReplace,
  Fingerprint,
  FlightLand,
  FlightTakeoff,
  FlipToBack,
  FlipToFront,
  GTranslate,
  Gavel,
  GetApp,
  Gif,
  Grade,
  GroupWork,
  Help as HelpIcon,
  HelpOutline,
  HighlightOff,
  History,
  Home,
  HorizontalSplit,
  HourglassEmpty,
  HourglassFull,
  Http,
  Https,
  ImportantDevices,
  Info as InfoIcon,
  InfoOutline,
  Input,
  InvertColors,
  Label as LabelIcon,
  LabelImportant,
  LabelOff,
  Language as LanguageIcon,
  Launch,
  LineStyle,
  LineWeight,
  List as ListIcon2,
  Lock,
  LockOpen,
  Loyalty,
  MarkunreadMailbox,
  Maximize,
  Minimize,
  Motorcycle,
  NoteAdd,
  OfflineBolt,
  OfflinePin,
  Opacity,
  OpenInBrowser,
  OpenInNew,
  OpenWith,
  Pageview,
  PanTool,
  Payment as PaymentIcon,
  PermCameraMic,
  PermContactCalendar,
  PermDataSetting,
  PermDeviceInformation,
  PermIdentity,
  PermMedia,
  PermPhoneMsg,
  PermScanWifi,
  Pets,
  PictureInPicture,
  PictureInPictureAlt,
  PlayForWork,
  Polymer,
  PowerSettingsNew,
  PregnantWoman,
  Print as PrintIcon,
  QueryBuilder,
  QuestionAnswer,
  Receipt as ReceiptIcon,
  RecordVoiceOver,
  Redeem,
  RemoveShoppingCart,
  Reorder,
  ReportProblem,
  Restore,
  RestoreFromTrash,
  RestorePage,
  Room,
  RoundedCorner,
  Rowing,
  Schedule as ScheduleIcon,
  Search,
  Settings as SettingsIcon,
  SettingsApplications,
  SettingsBackupRestore,
  SettingsBluetooth,
  SettingsBrightness,
  SettingsCell,
  SettingsEthernet,
  SettingsInputAntenna,
  SettingsInputComponent,
  SettingsInputComposite,
  SettingsInputHdmi,
  SettingsInputSvideo,
  SettingsOverscan,
  SettingsPhone,
  SettingsPower,
  SettingsRemote,
  SettingsVoice,
  Shop,
  ShopTwo,
  ShoppingBasket,
  ShoppingCart,
  SpeakerNotes,
  SpeakerNotesOff,
  Spellcheck,
  StarRate,
  Stars,
  Store,
  Subject,
  SupervisedUserCircle,
  SupervisorAccount,
  SwapHoriz,
  SwapVert,
  SwapVerticalCircle,
  SystemUpdateAlt,
  Tab,
  TabUnselected,
  Theaters,
  ThreeDRotation,
  ThumbDown as ThumbDownIcon,
  ThumbUp as ThumbUpIcon,
  ThumbsUpDown,
  Timeline,
  Toc,
  Today,
  Toll,
  TrackChanges,
  Translate,
  TrendingDown,
  TrendingUp as TrendingUpIcon,
  TurnedIn,
  TurnedInNot,
  Update,
  VerifiedUser,
  VerticalSplit,
  ViewAgenda,
  ViewArray,
  ViewCarousel,
  ViewColumn,
  ViewDay,
  ViewHeadline,
  ViewList as ViewListIcon,
  ViewModule as ViewModuleIcon,
  ViewQuilt,
  ViewStream,
  ViewWeek,
  Visibility,
  VisibilityOff,
  VoiceOverOff,
  Work as WorkIcon,
  WorkOff,
  WorkOutline,
  YoutubeSearchedFor,
  ZoomIn,
  ZoomOut,
} from '@mui/icons-material';

const StyledCard = styled(Card)(({ theme, viewMode }) => ({
  height: '100%',
  borderRadius: theme.spacing(2),
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  cursor: 'pointer',
  overflow: 'hidden',
  position: 'relative',
  
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
    borderColor: alpha(theme.palette.primary.main, 0.3),
  },
  
  '&:active': {
    transform: 'translateY(-2px)',
  },
  
  // Grid view specific styling
  ...(viewMode === 'grid' && {
    display: 'flex',
    flexDirection: 'column',
  }),
  
  // List view specific styling
  ...(viewMode === 'list' && {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(2),
    
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  }),
}));

const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  height: 200,
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(45deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.3) 100%)',
  },
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: 80,
  height: 80,
  border: `3px solid ${theme.palette.background.paper}`,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
}));

const DoctorCard = ({
  doctor,
  viewMode = 'grid',
  isFavorite = false,
  onFavoriteToggle,
  onSelect,
  onBookAppointment,
  onViewProfile,
  onShare,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showMore, setShowMore] = useState(false);

  // Default values for missing data
  const {
    id,
    name = 'Dr. Unknown',
    specialization = 'Adult Psychiatry',
    experience = 0,
    rating = 0,
    total_reviews = 0,
    consultation_fee = 0,
    location = 'Location not specified',
    languages = [],
    availability = 'Available',
    profile_image,
    bio = 'No bio available',
    verified = false,
    accepting_new_patients = true,
    video_consultation = true,
    phone_consultation = true,
    in_person_consultation = true,
    next_available = 'Today',
    distance = '2.5 km',
  } = doctor;

  const handleCardClick = () => {
    if (onSelect) {
      onSelect(doctor);
    }
  };

  const handleBookClick = (e) => {
    e.stopPropagation();
    if (onBookAppointment) {
      onBookAppointment(doctor);
    }
  };

  const handleViewProfileClick = (e) => {
    e.stopPropagation();
    if (onViewProfile) {
      onViewProfile(doctor);
    }
  };

  const handleFavoriteClick = (e) => {
    e.stopPropagation();
    if (onFavoriteToggle) {
      onFavoriteToggle(id);
    }
  };

  const handleShareClick = (e) => {
    e.stopPropagation();
    if (onShare) {
      onShare(doctor);
    }
  };

  const getAvailabilityColor = () => {
    if (availability === 'Available') return 'success';
    if (availability === 'Limited') return 'warning';
    return 'error';
  };

  const getExperienceText = () => {
    if (experience === 0) return 'New';
    if (experience === 1) return '1 year';
    return `${experience} years`;
  };

  const getConsultationTypes = () => {
    const types = [];
    if (video_consultation) types.push('Video');
    if (phone_consultation) types.push('Phone');
    if (in_person_consultation) types.push('In-Person');
    return types;
  };

  // Grid View (Default)
  if (viewMode === 'grid') {
    return (
      <StyledCard viewMode={viewMode} onClick={handleCardClick}>
        <StyledCardMedia
          image={profile_image || '/images/default-doctor.jpg'}
          title={name}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 12,
              right: 12,
              display: 'flex',
              gap: 1,
            }}
          >
            {verified && (
              <Tooltip title="Verified Doctor">
                <Badge
                  badgeContent={<Verified sx={{ fontSize: 12 }} />}
                  color="primary"
                >
                  <Box />
                </Badge>
              </Tooltip>
            )}
            <Tooltip title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}>
              <IconButton
                size="small"
                onClick={handleFavoriteClick}
                sx={{
                  backgroundColor: alpha(theme.palette.background.paper, 0.9),
                  '&:hover': {
                    backgroundColor: theme.palette.background.paper,
                  },
                }}
              >
                {isFavorite ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />}
              </IconButton>
            </Tooltip>
          </Box>
        </StyledCardMedia>

        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
            <StyledAvatar
              src={profile_image || '/images/default-doctor.jpg'}
              alt={name}
              sx={{ mr: 2, mt: -4 }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 0.5 }}>
                {name}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {specialization}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Rating value={rating} readOnly size="small" />
                <Typography variant="body2" color="text.secondary">
                  ({total_reviews})
                </Typography>
              </Box>
            </Box>
          </Box>

          <Stack spacing={1} sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {location} • {distance}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Work sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                {getExperienceText()} experience
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Payment sx={{ fontSize: 16, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                ₹{consultation_fee} consultation fee
              </Typography>
            </Box>
          </Stack>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
            {getConsultationTypes().map((type) => (
              <Chip
                key={type}
                label={type}
                size="small"
                variant="outlined"
                color="primary"
              />
            ))}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Chip
              label={availability}
              color={getAvailabilityColor()}
              size="small"
              icon={<CheckCircle />}
            />
            <Typography variant="body2" color="text.secondary">
              Next: {next_available}
            </Typography>
          </Box>
        </CardContent>

        <CardActions sx={{ p: 3, pt: 0 }}>
          <Button
            variant="contained"
            fullWidth
            onClick={handleBookClick}
            sx={{
              background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
              fontWeight: 600,
            }}
          >
            Book Appointment
          </Button>
        </CardActions>
      </StyledCard>
    );
  }

  // List View
  return (
    <StyledCard viewMode={viewMode} onClick={handleCardClick}>
      <CardContent sx={{ p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3} md={2}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <StyledAvatar
                src={profile_image || '/images/default-doctor.jpg'}
                alt={name}
                sx={{ mb: 2 }}
              />
              {verified && (
                <Tooltip title="Verified Doctor">
                  <Badge
                    badgeContent={<Verified sx={{ fontSize: 12 }} />}
                    color="primary"
                  >
                    <Box />
                  </Badge>
                </Tooltip>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} sm={6} md={7}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" component="h3" sx={{ fontWeight: 600, mb: 0.5 }}>
                {name}
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                {specialization}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Rating value={rating} readOnly size="small" />
                <Typography variant="body2" color="text.secondary">
                  ({total_reviews} reviews)
                </Typography>
              </Box>
            </Box>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={6} sm={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    {location}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Work sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    {getExperienceText()}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Payment sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    ₹{consultation_fee}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AccessTime sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    {next_available}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <MyLocation sx={{ fontSize: 16, color: 'text.secondary' }} />
                  <Typography variant="body2" color="text.secondary">
                    {distance}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={6} sm={4}>
                <Chip
                  label={availability}
                  color={getAvailabilityColor()}
                  size="small"
                  icon={<CheckCircle />}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
              {getConsultationTypes().map((type) => (
                <Chip
                  key={type}
                  label={type}
                  size="small"
                  variant="outlined"
                  color="primary"
                />
              ))}
            </Box>

            {languages.length > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                  Languages: {languages.slice(0, 3).join(', ')}
                  {languages.length > 3 && ` +${languages.length - 3} more`}
                </Typography>
              </Box>
            )}

            {showMore && (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {bio}
              </Typography>
            )}

            <Button
              size="small"
              onClick={() => setShowMore(!showMore)}
              sx={{ p: 0, minWidth: 'auto' }}
            >
              {showMore ? 'Show less' : 'Show more'}
            </Button>
          </Grid>

          <Grid item xs={12} sm={3} md={3}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Tooltip title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}>
                  <IconButton size="small" onClick={handleFavoriteClick}>
                    {isFavorite ? <FavoriteIcon color="error" /> : <FavoriteBorderIcon />}
                  </IconButton>
                </Tooltip>
                <Tooltip title="Share">
                  <IconButton size="small" onClick={handleShareClick}>
                    <Share />
                  </IconButton>
                </Tooltip>
                <Tooltip title="More options">
                  <IconButton size="small">
                    <MoreVert />
                  </IconButton>
                </Tooltip>
              </Box>

              <Button
                variant="contained"
                fullWidth
                onClick={handleBookClick}
                sx={{
                  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                  fontWeight: 600,
                }}
              >
                Book Appointment
              </Button>

              <Button
                variant="outlined"
                fullWidth
                onClick={handleViewProfileClick}
                startIcon={<Info />}
              >
                View Profile
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </StyledCard>
  );
};

export default DoctorCard;
